export default {
  data() {
    return {
      day: null,
      month: null,
      year: null,
    };
  },

  computed: {
    years() {
      const date = new Date();

      const currentYear = date.getFullYear();

      const startYear = currentYear - 85;
      const endYear = currentYear + 15;

      const years = [];

      for (let i = startYear; i < endYear; i += 1) {
        years.push({
          id: i + 1,
          label: i + 1,
        });
      }
      return years;
    },
    days() {
      const end = 31;

      const days = [];

      for (let i = 0; i < end; i += 1) {
        days.push({
          id: `${i + 1}`.padStart(2, '0'),
          label: `${i + 1}`.padStart(2, '0'),
        });
      }

      return days;
    },

    months() {
      return [
        { id: '01', label: 'January' },
        { id: '02', label: 'February' },
        { id: '03', label: 'March' },
        { id: '04', label: 'April' },
        { id: '05', label: 'May' },
        { id: '06', label: 'June' },
        { id: '07', label: 'July' },
        { id: '08', label: 'August' },
        { id: '09', label: 'September' },
        { id: '10', label: 'October' },
        { id: '11', label: 'November' },
        { id: '12', label: 'December' },
      ];
    },
  },

  methods: {
    setSelected() {
      if (this.day === null || this.month === null || this.year === null) {
        this.$emit('change', null);
        return;
      }

      this.$emit('change', `${this.year}-${this.month}-${this.day}`);
    },
    setInitialValue() {
      if (!this.question.initialVal || !this.question.initialVal.length) return;

      const date = new Date(this.question.initialVal);

      this.year = date.getUTCFullYear();
      this.month = `${date.getUTCMonth() + 1}`.padStart(2, '0');
      this.day = `${date.getUTCDate()}`.padStart(2, '0');

      this.$emit('change', `${this.year}-${this.month}-${this.day}`);
    },
  },
};
